import { SubmissionError } from 'redux-form';
import { fetch } from '../../utils/dataAccess';

export function error(error) {
  return { type: 'INVITATION_INTERVIEW_STATUS_CREATE_ERROR', error };
}

export function loading(loading) {
  return { type: 'INVITATION_INTERVIEW_STATUS_CREATE_LOADING', loading };
}

export function success(created) {
  return { type: 'INVITATION_INTERVIEW_STATUS_CREATE_SUCCESS', created };
}

export function create(values) {
  return dispatch => {
    dispatch(loading(true));

    return fetch('invitation_interview_statuses', { method: 'POST', data: values })
      .then(response => {
        dispatch(loading(false));
        dispatch(success(response.data));
      })
      .catch(e => {
        dispatch(loading(false));

        if (e instanceof SubmissionError) {
          dispatch(error(e.errors._error));
          throw e;
        }

        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return dispatch => {
    dispatch(loading(false));
    dispatch(error(null));
    dispatch(success(null));
  };
}
